import React from 'react';

/**
 * MESP brand mark.
 *
 * Variants:
 *   - "default" → transparent PNG, suitable for any light background.
 *   - "white"   → light-on-dark version, for navy/dark headers.
 *   - "full"    → main marketing artwork with the cream backdrop.
 *
 * `size` controls the rendered height in pixels — the aspect ratio is kept
 * 1:1 because the source artwork is square.
 */
export const Logo = ({ variant = 'default', size = 36, className = '', withText = false, testId }) => {
  const src =
    variant === 'white' ? '/mesp-logo-white.png' :
    variant === 'full'  ? '/mesp-logo-full.png'  :
                          '/mesp-logo.png';
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid={testId || 'brand-logo'}
    >
      <img
        src={src}
        alt="MESP"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: 'contain' }}
        draggable={false}
      />
      {withText && (
        <span className="flex flex-col leading-tight">
          <strong className="text-base font-semibold text-[#0A1128]">MESP</strong>
          <span className="text-[10px] text-[#5C6B8C]">المنصة الإلكترونية الاستراتيجية الحديثة</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
